
import { useEffect } from "react";
import styled from "styled-components"
import useCompleteGame from "../../modules/main/hooks/use-complete-game";
import useRestart from "../../modules/user/hooks/use-restart";
import useBodyClass from "../loyauts/use-body-class";
import NextButton from "../next-button";
import NiceButton from "../nice-button";
import EndGameContent from "./content";

type Props = {
    libCode: string;
    onClose(): void;
}

const Container = styled.div`
    display: block;
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;

    background: rgba(0,0,0,.8);

    .end-game-container {
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
    }

    h2 {
        color: white;
        text-align: center;

        font-family: "blokpol", sans-serif;
        font-size: 2.4rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: normal;
        word-spacing: 0.05em;
        margin: 0.67em 0 0.25em;

    }

    .post-page-box-links {
    justify-content: space-between;
    }
`;

const EndGamePopup: React.FC<Props> = ({ libCode, onClose }) => {

    useBodyClass('popup');

    const resetTasks = useRestart();
    const {completeGame} =  useCompleteGame();

    useEffect(() => {
        completeGame();
    }, [completeGame])

    return <Container>
        <div className="end-game-container">
            <h2>Gratulacje!</h2>
            <div className="page-box">
                <div className="page-box-content">
                    <EndGameContent libraryCode={libCode} />
                </div>
            </div>
            <div className="post-page-box-links">
                <NiceButton onClick={() => {
                    resetTasks();
                    onClose();
                }}>Zacznij od nowa</NiceButton>
                <NextButton onClick={onClose}>Wróć do mapy</NextButton>
            </div>

        </div>
    </Container>
}

export default EndGamePopup;
